import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { AppContext } from "../../App";
import { action, controller } from "../../api/Server";
import { Alert, Dialog, DynamicTable } from "../../layout";
import { AddEditRole } from "..";
import { IconButton, Tooltip } from "@mui/material";
import { ClearRounded, EditRounded } from "@mui/icons-material";
import { Button } from "../../controls";
import { formatDate } from "../../hooks/Method";

const RoleList = () => {
  const { t } = useTranslation();
  const { setPageTitle } = useContext(AppContext);
  const [refreshKey, setRefreshKey] = useState(0);
  const [updData, setUpdData] = useState();
  const [showForm, setShowForm] = useState(false);
  const [roleList, setRoleList] = useState([]);
  const [tblData, setTblData] = useState([]);
  const [alert, setAlert] = useState({
    isOpen: false,
    type: "",
    title: "",
    subTitle: "",
  });

  useEffect(() => {
    setPageTitle("User Role");
    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleAddEdit = (val) => {
    setUpdData(val);
    setShowForm(true);
  };

  const handleDlt = () => {};

  useEffect(() => {
    setTblData([
      ...roleList.map((j) => ({
        ...j,
        createDate: formatDate(j.createDate),
        updateDate: formatDate(j.updateDate),
      })),
    ]);
    return () => {};
  }, [roleList]);

  const HeaderComp = () => (
    <Button
      onClick={handleAddEdit}
      variant="text"
      size="small"
      sx={{
        width: { md: "180px", xs: "100%" },
        fontSize: "16px",
        padding: "5px",
      }}
    >
      {t("addRole")}
    </Button>
  );

  const ActionComp = (props) => (
    <div className="bs-secondary br-8 w-fit bg-white">
      <Tooltip arrow title={t("edit")}>
        <IconButton
          onClick={() => handleAddEdit(props)}
          size="small"
          className="mr-5"
          color="primary"
        >
          <EditRounded className="fs-18 m-2" />
        </IconButton>
      </Tooltip>

      <Tooltip arrow title={t("delete")}>
        <IconButton
          onClick={() => handleDlt(props.id)}
          size="small"
          className="error-color"
        >
          <ClearRounded className="fs-18 m-2" />
        </IconButton>
      </Tooltip>
    </div>
  );
  return (
    <>
      <DynamicTable
        key={refreshKey}
        records={tblData}
        setRecords={setRoleList}
        endpointKey={controller.UserRole + action.GetAllByOrgPg}
        ActionComp={ActionComp}
        HeaderComp={() => <HeaderComp {...{ handleAddEdit }} />}
        headers={[
          { id: "actions", label: t("actions") },
          { id: "title", label: t("title") },
          { id: "subtitle", label: t("subtitle") },
          { id: "createDate", label: t("createDate") },
          { id: "updateDate", label: t("lastUpdateDate") },
        ]}
      />

      {/* Alert  */}
      <Alert alert={alert} setAlert={setAlert} />

      {/* Add Edit Form */}
      {showForm && (
        <Dialog show={showForm} onClose={false} maxWidth="md">
          <AddEditRole
            {...{ updData, setShowForm, setTblData, setRefreshKey }}
          />
        </Dialog>
      )}
    </>
  );
};

export default RoleList;
